// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"ac978a26","963":"4ee13cc1","975":"820b73cf"}[chunkId] + ".chunk.js";
};